import { useAtom } from '@reatom/npm-react'
import * as DateF from 'date-fns'
import styled from 'styled-components'

import { dateBySecondAtom } from '@root/shared/lib'
import { useDateFnsLocale, useTranslation } from '@root/shared/localization'

type TrackedWalletTableLastActiveCellProps = {
  lastTradeAt: Date
}

export const TrackedWalletTableLastActiveCell: React.FC<
  TrackedWalletTableLastActiveCellProps
> = ({ lastTradeAt }) => {
  const locale = useDateFnsLocale()
  const { t } = useTranslation()
  const [now] = useAtom(dateBySecondAtom)

  const time = DateF.formatDistance(lastTradeAt, now, {
    locale,
    includeSeconds: true,
  })
  const timeAgo = time ? t('common.ago', { time }) : t('common.n_a')

  return (
    <Root>
      <Text>{timeAgo}</Text>
    </Root>
  )
}

const Root = styled.div`
  overflow: hidden;
  height: 34px;
`
const Text = styled.div`
  color: var(--text-11);

  overflow: hidden;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
`
